import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { analytics } from '@/shared/lib/analytics';

/**
 * Hook to track page views in RudderStack on route changes
 */
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view on location change
    analytics.page();
  }, [location.pathname]);
};
